"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, MotionValue, useTransform } from "framer-motion";
interface TypedCharProps {
  char: string;
  /** Shared 0→1 typing progress; this letter reveals inside [from, to]. */
  progress: MotionValue<number>;
  from: number;
  to: number;
}

// One letter of the typed vertical heading. Its reveal window is a slice of the
// shared progress, so the letters light up in sequence down the column rather
// than the whole line arriving at once.
const TypedChar = t0 => {
  const $ = _c(15);
  const {
    char,
    progress,
    from,
    to
  } = t0;
  let t1;
  if ($[0] !== from || $[1] !== to) {
    t1 = [from, to];
    $[0] = from;
    $[1] = to;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [0, 1];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const opacity = useTransform(progress, t1, t2);
  let t3;
  if ($[4] !== from || $[5] !== to) {
    t3 = [from, to];
    $[4] = from;
    $[5] = to;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["0.2em", "0em"];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const y = useTransform(progress, t3, t4);
  if (char === " ") {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <span> </span>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t5;
  if ($[9] !== opacity || $[10] !== y) {
    t5 = {
      opacity,
      y
    };
    $[9] = opacity;
    $[10] = y;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== char || $[13] !== t5) {
    t6 = <motion.span style={t5} className="inline-block">{char}</motion.span>;
    $[12] = char;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default TypedChar;